import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiURI, mainSite } from '../config.js';
import Bugsnag from '@bugsnag/expo';
import { PivotLogging } from './cbcLoggingSlice.js';

const initialState = {
    loading_msg: 'idle',
    results_msg: '',
};

export const resetPassword = createAsyncThunk(
    'accountActions/resetPassword',
    async (userEmail, { dispatch, rejectWithValue }) => {
        try {
            console.log('Action resetPassword dispatched', userEmail);
            const response = await fetch(`${apiURI}/app-specific/reset-password.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({ user_email: userEmail }),
            });

            const results = await response.json();
            console.log(`resetPassword results: ${JSON.stringify(results)}`);

            if (!response.ok) {
                throw new Error(response.statusText);
            }

            if (!results.success) {
                return rejectWithValue(results.msg);
            }

            return results;
        } catch (error) {
            dispatch(PivotLogging({
                moduleName: 'accountActions',
                consoleLog: `Api Error, send-password-reset-email: ${error.message}`
            }));
            Bugsnag.notify('Api Error, send-password-reset-email: ' + error.message);
            return rejectWithValue(error.message);
        }
    }
);

export const cbcAccountActions = createSlice({
    name: 'accountActions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(resetPassword.pending, (state) => {
                state.loading_msg = 'pending';
                state.results_msg = 'Attempting to send password reset email';
            })
            .addCase(resetPassword.fulfilled, (state, { payload }) => {
                state.loading_msg = 'idle';
                state.results_msg = 'Successfully sent password reset email.';
            })
            .addCase(resetPassword.rejected, (state, { payload }) => {
                state.loading_msg = 'failed';
                state.results_msg = payload;
                console.log('rejected payload', payload);
            });
    },
});

export default cbcAccountActions.reducer;